// extracted by mini-css-extract-plugin
export var editButton = "_o7-0";